module.exports = __webpack_public_path__ + "static/media/2023_14.fe665586.jpg";